export * from './heading.module';
